import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';

const Hour = (props) => {
  const styles = StyleSheet.create({
    hourContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      width: `${props.hourWidth}px`,
      minWidth: `${props.hourWidth}px`
    },
    hour: {
      width: `${(props.hourWidth - 32) / 2}px`,
      minWidth: `${(props.hourWidth - 32) / 2}px`, // '33px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    hourMarkerText: {
      fontSize: '12px',
      fontWeight: 'bold',
      height: '20px'
    },
    hourMarker: {
      width: '1px',
      minWidth: '1px',
      background: 'white',
      height: '20px'
    },

    halfHour: {
      margin: '0 16px',
      width: `${(props.hourWidth - 32) / 2}px`,
      minWidth: `${(props.hourWidth - 32) / 2}px`,
      // width: '33px',
      // minWidth: '33px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    halfHourMarkerText: {
      fontSize: '12px',
      fontWeight: 'bold',
      height: '20px'
    },
    halfHourMarker: {
      width: '1px',
      minWidth: '1px',
      background: 'white',
      height: '10px'
    }
  });

  return (
    <div className={`noselect ${css(styles.hourContainer)}`}>
        <div className={css(styles.hour)}>
          <div className={css(styles.hourMarkerText)}>
            {props.label}
          </div>
          <div className={css(styles.hourMarker)} />
        </div>
        <div className={css(styles.halfHour)}>
          <div className={css(styles.halfHourMarkerText)}>
            30
          </div>
          <div className={css(styles.halfHourMarker)} />
        </div>
      </div>
  );
};

export default Hour;
